// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = [
    `undo redo searchreplace | bold italic underline strikethrough | formatselect fontselect fontsizeselect styleselect | preview print fullscreen`,
    `forecolor backcolor removeformat | alignleft aligncenter alignright outdent indent | bullist numlist | blockquote subscript superscript hr link image charmap table 
        insertdatetime media`// , `code`
    ]

export default toolbar



// WEBPACK FOOTER //
// ./src/tycomponents/Editor/toolbar.js